import { Link } from 'react-router-dom';
import { FREE_PLAN } from '../config/plans';

const PaymentAlert = ({ status, plan }) => {
    const isDemo = plan === FREE_PLAN;
    const isExpired = status === 'canceled';

    const config = isDemo && isExpired
        ? {
              variant: 'danger',
              message: 'Vaša skúšobná verzia vypršala. Pre pokračovanie si zakúpte platený plán.',
              cta: 'Kúpiť plán',
          }
        : isDemo
        ? {
              variant: 'warning',
              message: 'Používate Demo plán. Niektoré funkcie sú obmedzené.',
              cta: 'Prejsť na platený plán',
          }
        : status === 'past_due'
        ? {
              variant: 'warning',
              message: 'Platba za predplatné zlyhala. Aktualizujte platobné údaje.',
              cta: 'Spravovať predplatné',
          }
        : {
              variant: 'danger',
              message: 'Vaše predplatné vypršalo. Obnovte ho pre plný prístup.',
              cta: 'Obnoviť predplatné',
          };

    return (
        <div className={`alert alert-${config.variant} mt-3 d-flex align-items-center justify-content-between flex-wrap gap-2`}>
            <span>{config.message}</span>
            <Link
                to="/billing"
                className={`btn btn-sm btn-${config.variant} fw-semibold`}
                style={{ whiteSpace: 'nowrap' }}
            >
                {config.cta}
            </Link>
        </div>
    );
};

export default PaymentAlert;
